import { Sheet } from '@hover/blueprint';
import React from 'react';

import { UploadPhotoSheet } from 'src/modules/homeownerApp/components/SheetMenu/UploadPhotoSheet';
import { useProPageContext } from 'src/modules/pro/hooks/useProPageContext';

const PhotoUploadSheet = ({
  isOpen,
  onClose,
  orgDisplayName,
}: {
  isOpen: boolean;
  onClose: () => void;
  orgDisplayName?: string;
}) => {
  const { setImageFileToUpload } = useProPageContext();

  return (
    <Sheet autoFocus={false} isOpen={isOpen} onClose={onClose} variant="bottom">
      <UploadPhotoSheet
        callback={onClose}
        orgDisplayName={orgDisplayName}
        setImageFileToUpload={setImageFileToUpload}
      />
    </Sheet>
  );
};

export { PhotoUploadSheet };
